import httpService from "./http.service";

class FormService {
    getUrl = "/form-sections";

    getFormSections = (formId) => {
        return httpService.get(this.getUrl + `/${formId}`);
    };
    createFormSection = (model) => {
        return httpService.post("/form-sections", model);
    };
    editFormSection = (id, model) => {
        return httpService.patch("/form-sections/" + id, model);
    };
    deleteFormSection = (id) => {
        return httpService.delete("/form-sections/" + id);
    };
}

const formService = new FormService();
export default formService;